module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intern-notes-container"
  }, [_c('button', {
    staticClass: "open-button",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v("Interne noter "), (_vm.noteText.length > 1) ? _c('div', {
    staticClass: "dot"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subs-note",
    class: {
      'subs-note--is-open': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "subs-note__container"
  }, [_c('div', {
    staticClass: "subs-note__container__header"
  }, [_c('div', {
    staticClass: "subs-note__container__header__close",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v("Dagens interne noter")])]), _vm._v(" "), _c('div', {
    staticClass: "subs-note__container__body"
  }, [_c('h3', [_vm._v("Noter til " + _vm._s(_vm.showDate))]), _vm._v(" "), _c('div', {
    staticClass: "subs-note__container__note"
  }, [_c('AppEIPWYZIWYG', {
    attrs: {
      "textInput": _vm.noteText
    },
    on: {
      "close": _vm.updateNoteText
    }
  })], 1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        _vm.isOpen = false
      }
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44dc2b0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsNote.vue
// module id = 1555
// module chunks = 1